import { useEffect, useState } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { IconArrowLeftSlide, IconArrowRightSlide } from '../icons/MainIcons';
import Autoplay from 'embla-carousel-autoplay';
import { getStorageUrl } from '@/utils/utils';

const SeriesShots = ({ shots }) => {
    const [emblaRef, emblaApi] = useEmblaCarousel({ align: 'start', slidesToScroll: 1 });

    const [selectedIndex, setSelectedIndex] = useState(0);
    const [slides, setSlides] = useState([]);

    const onSelect = () => {
        if (!emblaApi) return;
        setSelectedIndex(emblaApi.selectedScrollSnap());
    };

    useEffect(() => {
        if (!emblaApi) return;
        setSlides([...Array(emblaApi.slideNodes().length).keys()]);
        emblaApi.on('select', onSelect);
        onSelect();
    }, [emblaApi]);

    return (
        <div className="xl:mt-[100px] lg:mt-[90px] md:mt-[80px] sm:mt-[65px] mt-[50px]">
            <h4 className="seriesHead mainContainer">لقطات من المسلسل</h4>
            <div className="mt-[40px] relative mainContainer-seriesShots">
                <button
                    onClick={() => emblaApi?.scrollPrev()}
                    className="arrowSlide-series absolute sm:left-6 left-3 top-1/2 transform -translate-y-1/2"
                >
                    <IconArrowLeftSlide className="iconArrow" />
                </button>

                <div className="embla mainContainer" ref={emblaRef}>
                    <div className="embla__container-serios mr-[-12px]">
                        {shots?.map((image, index) => (
                            <div className="embla__slide-serios" key={index}>
                                <div className="w-full h-full bg-cover max-w-[405px] max-h-[240px] rounded-[16px]">
                                    <img
                                        src={getStorageUrl(image)}
                                        alt={`Project Image ${index + 1}`}
                                        className="w-full h-full object-cover rounded-[16px]"
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <button
                    onClick={() => emblaApi?.scrollNext()}
                    className="arrowSlide-series absolute sm:right-6 right-3 top-1/2 transform -translate-y-1/2"
                >
                    <IconArrowRightSlide className="iconArrow" />
                </button>
            </div>
        </div>
    );
};

export default SeriesShots;
